import { useDispatch, useSelector } from 'react-redux';
import Notifications from 'redux/Notifications';

const useNotifications = () => {
  const dispatch = useDispatch();
  const getAllNotifications = useSelector(Notifications.getAllNotifications);
  const getNotificationsLength = useSelector(Notifications.getNotificationsLength);

  const setError = (error) => {
    dispatch(Notifications.setError(error));
  };
  const setWarning = (notificationMessage, title) => {
    dispatch(Notifications.setWarning(notificationMessage, title));
  };
  const setInfo = (notificationMessage, title) => {
    dispatch(Notifications.setInfo(notificationMessage, title));
  };
  const setSuccess = (notificationMessage, title) => {
    dispatch(Notifications.setSuccess(notificationMessage, title));
  };
  const clearAllNotificationsBySeverity = (severity) => {
    dispatch(Notifications.clearAllNotificationsBySeverity(severity));
  };
  const clearSingleNotification = (key) => {
    dispatch(Notifications.clearSingleNotification(key));
  };
  const clearNotifications = () => {
    dispatch(Notifications.clearNotifications());
  };
  return {
    setError,
    setWarning,
    clearAllNotificationsBySeverity,
    clearSingleNotification,
    clearNotifications,
    setInfo,
    setSuccess,
    getAllNotifications,
    getNotificationsLength,
  };
};

export default useNotifications;
